import { Reducer } from "redux";

import { GetIsRetroDetailsDispatchTypes } from "../models/dispatchTypes/Referral";
import { IsRetroDetailsResponse } from "../models/api/Referral";
import { GetIsRetroDetailsActionDispatchTypes } from "../constants/Referral";

const initialState: IsRetroDetailsResponse = {
    loading: false,
    response: {
        isRetro: false,
        effectiveEndDate: "",
        effectiveEndDateMinOneDay: "",
    },
    error: null,
};

const IsRetroDetailsReducer: Reducer<
    IsRetroDetailsResponse,
    GetIsRetroDetailsDispatchTypes
> = (state = initialState, action) => {
    switch (action.type) {
        case GetIsRetroDetailsActionDispatchTypes.GET_IS_RETRO_DETAILS_INVOKE: {
            return {
                ...state,
                loading: true,
            };
        }
        case GetIsRetroDetailsActionDispatchTypes.GET_IS_RETRO_DETAILS_SUCCESS: {
            return {
                ...state,
                response: action.response,
                loading: false,
            };
        }
        case GetIsRetroDetailsActionDispatchTypes.GET_IS_RETRO_DETAILS_ERROR: {
            return {
                ...state,
                error: action.error,
                loading: false,
            };
        }
        case GetIsRetroDetailsActionDispatchTypes.GET_IS_RETRO_DETAILS_RESET: {
            return initialState;
        }
    }
    return state;
};
export default IsRetroDetailsReducer;
